<div id="payment" class="registration container" *ngIf="programInfo">
    <form #paymentForm="ngForm" name="paymentForm" (ngSubmit)="forward(paymentForm)"
        novalidate autocomplete="off" appScrollToInvalid
        [ngClass]="{'form-complete': isFormCompleted}">
        <h1>{{"copy.label.PAYMENT.heading"|copy|async}}</h1>

        <!-- <section class="card" name="conferenceFee" *ngIf="Total === 0">
            <app-collect-payment cardType="Conference"
            title="copy.label.PAYMENT.FEESRT10.guarantee"
            ></app-collect-payment>
        </section> -->

        <section class="card" name="conferenceFee" *ngIf="charges.Conference > 0">
            <app-collect-payment cardType="Conference"
            title="copy.label.PAYMENT.FEESRT10.conference"
            [cost]="charges.Conference|currency"></app-collect-payment>
        </section>



        <section class="card" name="guestFee" *ngIf="charges.Guest > 0 && attendee.PAXTypeNo !== 1">

            <app-collect-payment cardType="Guest"
            title="copy.label.PAYMENT.FEESRT10.guest"
            [cost]="charges.Guest|currency"></app-collect-payment>
        </section>
        <section class="card" name="guestFee" *ngIf="charges.Guest > 0 && attendee.PAXTypeNo === 1">

          <app-collect-payment cardType="Guest"
          title="copy.label.PAYMENT.FEESRT10.guest"
          additionaltext="copy.html.guestpagetext"
          [cost]="charges.Guest|currency"></app-collect-payment>
      </section>

        <section class="card" name="guestGuarantee" *ngIf="(attendee.PAXTypeNo === 1 && (!charges.Guest || charges.Guest==0)  && guests.length > 0)">
            
            <app-collect-payment cardType="Guest"
            title="copy.label.PAYMENT.FEESRT10.guestGuarantee"
            additionaltext="copy.html.guestpagetext"
            >
        </app-collect-payment>
        </section>
        
        <section class="card" name="guestGuarantee" *ngIf="(attendee.PAXTypeNo !== 1 && charges.Guest==0 && guests.length > 0)">
            
          <app-collect-payment cardType="Guest"
          title="copy.label.PAYMENT.FEESRT10.guestGuarantee"
         
          >
      </app-collect-payment>
      </section>
        
        <section class="card" name="guarantee" *ngIf="needGuarantee()">
            <app-collect-payment cardType="Guarantee"
            title="copy.label.PAYMENT.FEESRT10.guarantee"
            additionaltext="copy.html.OtherPayment" [ccOnly]="true"></app-collect-payment>
        </section>
        <section class="card" name="donation" *ngIf="donation.Value == 'Yes'">
            <app-collect-payment title="copy.label.PAYMENT.FEESRT10.donation"
            cardType="Donation" [ccOnly]="true"  [cost]="charges.Donation|currency"></app-collect-payment>
        </section>
        <div class="button_group d-flex">
          <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
            {{ 'copy.label.GLOBAL.goback' | copy | async }}
          </button>
          <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
            {{ 'copy.label.GLOBAL.continue' | copy | async }}
          </button>
          <button class="inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
            <i class="fas fa-spinner fa-spin"></i>
          </button>
        </div>
    </form>
</div>
